module.exports = __webpack_public_path__ + "img/wxpay.2ee6f53.png";